var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "search-results" }, [
    _vm.isLoaded === false
      ? _c(
          "div",
          { staticClass: "search-results-inner" },
          [_c("loading-spinner")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoaded
      ? _c(
          "div",
          { staticClass: "search-results-inner" },
          [
            _c("h1", { staticClass: "heading" }, [
              _vm._v(
                "Suchergebnisse für „" + _vm._s(_vm.$route.params["term"]) + "“"
              )
            ]),
            _vm._v(" "),
            _vm.isLoaded
              ? _c("tabbed-teaser", {
                  attrs: {
                    "teaser-filter-params": _vm.teaserFilterParams,
                    "show-categories-filter-param": false
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c44fcc3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c44fcc3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/SearchResults.vue
// module id = 638
// module chunks = 0